var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconLeftArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.043.416c.208.208.312.455.312.74 0 .284-.104.53-.312.74L2.939 7.998l6.125 6.125a.99.99 0 01.291.73c0 .291-.104.541-.312.75a1.012 1.012 0 01-.74.312 1.01 1.01 0 01-.74-.313l-7-7.02a.736.736 0 01-.177-.271.929.929 0 01-.051-.313c0-.11.017-.215.051-.312a.736.736 0 01.178-.271l7.02-7.02a.976.976 0 01.719-.292c.285 0 .532.104.74.312z",
    fill: "#393E4C"
  })));
}

export default SvgIconLeftArrow;